import { makeStyles } from "@material-ui/core";
import { getSharedStorageTransactionStyles } from "../shared/styles";

export const useStyles = makeStyles((theme) => ({
	...getSharedStorageTransactionStyles(theme),
	palletColumnFull: {
		padding: theme.spacing(2),
		backgroundColor: theme.palette.background.default,
	},
	columnHeaderMoved: {
		backgroundColor: theme.palette.secondary.light,
		color: theme.palette.secondary.dark,
		border: `1px solid ${theme.palette.secondary.light}`,
	},
	palletCardMoved: {
		borderLeft: `3px solid ${theme.palette.secondary.main}`,
		backgroundColor: theme.palette.background.paper,
	},
}));
